import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { sysConfigService } from 'services';

const initialState = {
  data: {},
  detailData: {},
  statusList: 'idle',
  statusDetail: '',
  statusSubmit: ''
};

export const getList = createAsyncThunk(
  'sysConfig/fetchList',
  async (data) => {
    const response = await sysConfigService.list(data);
    return response;
  }
);

export const getDetail = createAsyncThunk(
  'sysConfig/fetchById',
  async (data) => {
    const response = await sysConfigService.show(data);
    return response;
  }
);

export const editData = createAsyncThunk(
  'sysConfig/fetchUpdate',
  async (data) => {
    const response = await sysConfigService.update(data);
    return response;
  }
);

export const sysConfigSlice = createSlice({
  name: 'sysConfig',
  initialState: initialState,
  reducers: {
    setFilter: (state, action) => {
      const data = action.payload;
      state.filter = data;
    },
    resetData: (state, action) => {
      const payload = action.payload;
      if(typeof payload === 'string'){
        state[payload] = initialState[payload];
      }else if(Array.isArray(payload)){
        payload.forEach(item => 
          state[item] = initialState[item]
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getList.pending, (state) => {
        state.statusList = 'loading';
      })
      .addCase(getList.fulfilled, (state, action) => {
        state.statusList = 'success';
        state.data = action.payload;
      })
      .addCase(getList.rejected, (state) => {
        state.statusList = 'error';
      })
      .addCase(getDetail.pending, (state) => {
        state.statusDetail = 'loading';
      })
      .addCase(getDetail.fulfilled, (state, action) => {
        state.statusDetail = 'success';
        state.detailData = action.payload;
      })
      .addCase(getDetail.rejected, (state) => {
        state.statusDetail = 'error';
      })
      .addCase(editData.pending, (state) => {
        state.statusSubmit = 'loading';
      })
      .addCase(editData.fulfilled, (state) => {
        state.statusSubmit = 'success';
      })
      .addCase(editData.rejected, (state) => {
        state.statusSubmit = 'error';
      });
  }
});

export const { setFilter, resetData } = sysConfigSlice.actions;

const sysConfigReducer = sysConfigSlice.reducer;
export default sysConfigReducer;